(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-limits/deposit-limits.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-limits/deposit-limits.js');
'use strict';

const _React = React,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch;
const transactionLimitsChange = svs.accountservicesReact.deposit.store.deposit.actions.transactionLimitsChange;
const service = svs.accountservicesReact.deposit.depositLimitsService;
const DepositLimitsRow = svs.accountservicesReact.deposit.depositLimits.DepositLimitsRow;
const DepositLimits = () => {
  var _ReactRedux$useSelect;
  const limits = (_ReactRedux$useSelect = ReactRedux.useSelector(state => state.deposit.transactionLimits)) !== null && _ReactRedux$useSelect !== void 0 ? _ReactRedux$useSelect : [];
  const returnUrl = ReactRedux.useSelector(state => state.deposit.returnUrl);
  const dispatch = useDispatch();
  useEffect(() => {
    var _limits$;
    const getLimits = async () => {
      const _await$service$getDep = await service.getDepositLimitsAsync(),
        error = _await$service$getDep.error,
        data = _await$service$getDep.data;
      if (!error) {
        dispatch(transactionLimitsChange(data.limits));
      }
    };
    if (!limits || ((_limits$ = limits[0]) === null || _limits$ === void 0 ? void 0 : _limits$.currentDepositAmount) === undefined) {
      getLimits();
    }
    if (!returnUrl) {
      svs.components.account_balance.on('change', () => {
        getLimits();
      });
    }

  }, []);
  return React.createElement("div", {
    className: "margin-bottom-1 margin-top-4 padding-top-2 f-center"
  }, React.createElement("h3", {
    className: "h3 margin-bottom-1"
  }, "Dina ins\xE4ttningsgr\xE4nser"), limits.map(limit => React.createElement(DepositLimitsRow, {
    key: limit.limitType,
    limit: limit
  })), React.createElement("div", {
    className: "margin-v-2"
  }, React.createElement("a", {
    className: "f-medium u-text-decoration-underline",
    href: svs.core.urlMapping.get('myLimitsDepositUpdate')
  }, "\xC4ndra dina gr\xE4nser")));
};
svs.accountservicesReact.deposit.depositLimits.DepositLimits = DepositLimits;

 })(window);